/* eslint-disable @nx/enforce-module-boundaries */
import { Container, Stack } from '@mybridge/ui';
import { useRouter } from 'next/router';
import { forwardRef, useEffect, useState } from 'react';
import { BackButton } from 'v4/components/back-button';
import { ApplyJobModal } from '../apply-modal';
import { JobsListingContext, useJobsListingContext } from '../context';
import { ReportJobModal } from '../report-job-modal';
import Head from 'next/head';
import { useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';

export const JobsListingLayout = forwardRef(
  ({ showSearchBar = true, children, ...props }, ref) => {
    const { pathname, query } = useRouter();
    const { slug } = query ?? {};
    // const jobsContext = useJobsListingContext({ slug });
    // const jobsContext = useJobsListingContext({
    //   slug,
    //   refetchSearchJobsListingEnabled: pathname === '/jobs/search' || pathname?.includes('/jobs/search'),
    //   ...props,
    // });
    const { loggedIn } = useSelector((state) => state.user);
    const jobsContext = useJobsListingContext({
      slug,
      refetchSearchJobsListingEnabled: pathname === '/jobs/search' || pathname?.includes('/jobs/search'),
      refetchSuggestedJobsListingEnabled: pathname === '/jobs/suggested' || pathname === '/jobs',
      // refetchSavedJobsListingEnabled: pathname === '/jobs/suggested' || pathname === '/jobs' || pathname?.includes('/jobs/my/saved') || pathname?.includes('/jobs/my/applied'),
      // refetchAppliedJobsListingEnabled: pathname === '/jobs/suggested' || pathname === '/jobs' || pathname?.includes('/jobs/my/saved') || pathname?.includes('/jobs/my/applied'),
      refetchSavedJobsListingEnabled: !!loggedIn && (pathname === '/jobs/suggested' || pathname === '/jobs' || pathname?.includes('/jobs/my/saved') || pathname?.includes('/jobs/my/applied')),
      refetchAppliedJobsListingEnabled: !!loggedIn && (pathname === '/jobs/suggested' || pathname === '/jobs' || pathname?.includes('/jobs/my/saved') || pathname?.includes('/jobs/my/applied')),
      ...props,
    });
    // const { loggedIn } = useSelector((state) => state.user);
    const { globalNotifCount } = useSelector((state) => state.notifications);
    const { applyDisc, reportDisc } = jobsContext ?? {};
    const { filters } = jobsContext ?? {};
    const [showBanner, setShowBanner] = useState(false); 
    const isJobSaved = pathname?.includes('jobs/my/saved');
    const isJobApplied = pathname?.includes('jobs/my/applied');
    const isJobTrack = pathname?.includes('jobs/my/track');



    useEffect(() => {
      if (typeof window !== 'undefined') {
        window.addEventListener('wheel', (e) => {
          if (e.deltaY < 0) {
            setShowBanner(true);
          } else {
            setShowBanner(false);
          }
        });
      }
    }, []);

    return (
      <JobsListingContext.Provider value={jobsContext}>
        <Head>
          <title>
            {loggedIn && globalNotifCount ? `(${globalNotifCount})` : ''} Jobs |
            myBridge
          </title>
        </Head>
          {/* <Stack
              spacing={0}
              // pos="sticky"
              top="64px"
              zIndex={1}  
              mx={[0, 0, '-45px']}
              mt={["0px", "-20px"]}
            >
              <Stack px={[2, 2, '12']} py={2} w="100%" bg="brandPrimary.500">
                <BackButton />
              </Stack>
              <Stack w="100%">
                {showSearchBar ? <JobsListingSearchBar /> : ''}
              </Stack>
            </Stack> */}
            
          <Container   w="1320px" maxW="100%" height="calc(100vh - 70%)"  p={!isMobile ? ['5px 10px 0', 0] : [0, 2, 4]} py={3}>
            {children}
          </Container>
        {applyDisc?.isOpen ? <ApplyJobModal /> : ''}
        {reportDisc?.isOpen ? <ReportJobModal /> : ''}
      </JobsListingContext.Provider>
    );
  }
);
